module.exports = __webpack_public_path__ + "static/img/esquema.0214b24.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/esquema/esquema.png
// module id = wSQa
// module chunks = 0